import { PropsWithChildren } from 'react';
import { SidePanel, navLinks } from './SidePanel';
import { WDPNavbar } from './WDPNavbar';
import { useLocation } from 'react-router-dom';

export const Root = ({ children }: PropsWithChildren<{}>) => {
  const location = useLocation();
  // Map path to menu label
  const pathToLabel: Record<string, string> = {
    '/catalog': 'Catalog',
    '/domains': 'Domain',
  };
  const activeMenu = location.pathname.startsWith('/domains')
    ? 'Domain'
    : pathToLabel[location.pathname] || '';
  const TOP_OFFSET = 32;
  return (
    <>
      <WDPNavbar className="px-3 py-2" style={{ height: '50px' }} />
      <div className="flex h-100" style={{ paddingTop: TOP_OFFSET }}>
        <SidePanel navLinks={navLinks} activeMenu={activeMenu} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <main style={{ flex: 1 }}>{children}</main>
        </div>
      </div>
    </>
  );
};
